import { createTeamUnion } from "@redotech/account-common/create-team";
import * as z from "zod";

export const createTeam = {
  name: "createTeam" as const,
  input: createTeamUnion,
  output: z.object({
    success: z.boolean(),
    message: z.nullable(z.string()),
    team: z.string().nullable(),
  }),
};
